import React, {useContext, useEffect} from 'react';
import './App.css';
import '@exceed.ai/exceed-utils/dist/index.css'
import {Route, Switch, Redirect} from "react-router-dom";
import Login from 'components/Login';

import Main from 'containers/Main/Main'
import {AppStoreContext, SESSION_STATUS} from "components/Mall/AppStore/AppStore";
import {ExceedApiContext} from "./ExceedApi";
import {useObserver} from "mobx-react-lite";

const App = ({location}) => {

    const AppStore = useContext(AppStoreContext);
    const ExceedApi = useContext(ExceedApiContext);

    // do we need it with any conditions?
    useEffect(() => {
        let ref = window.location.hash.substr(1);
        if (VALIDATION_EXCLUSION.filter(loc => ref.startsWith(loc)).length === 0) {
            ExceedApi.validateSession().then((sessionData) => {
                AppStore.setSessionData(sessionData);
                AppStore.setSessionStatus(SESSION_STATUS.ESTABLISHED);
                // this.permissionsStore.updatePermissions(sessionData.permissions);
            }).catch((error) => {
                AppStore.setSessionStatus(SESSION_STATUS.UNSET);
            });
        }
    })

    return useObserver(() =>
        <div className="App">
            <Switch>
                <Route exact path="/login" name="Login Page" component={Login}/>
                {(SESSION_STATUS.LOADING === AppStore.getSessionStatus) && null /* Loading.. Could put a 'Loading, please wait' note here. */}
                {(SESSION_STATUS.UNSET === AppStore.getSessionStatus) &&
                <Redirect from={location} to={{
                    pathname: "/login",
                    state: {from: window.location.href.split("#")[1]}
                }}/>}
                {(SESSION_STATUS.ESTABLISHED === AppStore.getSessionStatus) &&
                (<Route path="/" name="Home" component={Main}/>)}
            </Switch>
        </div>
    );
}

const VALIDATION_EXCLUSION = [
    '/login',
    '/forgot-password',
    '/reset-password/',
    '/create-rep/',
    '/set-meeting/',
    '/sso-redirect-login',
    '/successful-oauth-login/',
    '/new-project'
];

export default App;
